import React from "react";
import { Link } from "react-router-dom";
import SeoHead from "../../components/seo/SeoHead";
import { SEO_BASE_URL, cityPages } from "../../data/seoPages";

function LocationsHubPage() {
  const title = "Bellhopt Locations | Airbnb Grocery Delivery";
  const description =
    "Explore Bellhopt locations for Airbnb grocery delivery that is stocked and organized by Bellhopt Concierge. 24-hour lead time required.";

  const structuredData = [
    {
      "@context": "https://schema.org",
      "@type": "WebPage",
      name: title,
      url: `${SEO_BASE_URL}/locations/`,
      description,
    },
    {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Locations",
          item: `${SEO_BASE_URL}/locations/`,
        },
      ],
    },
  ];

  return (
    <div className="w-full min-h-screen bg-[#F9FAFB] pt-[72px] font-segoe">
      <SeoHead
        title={title}
        description={description}
        canonical="/locations/"
        robots="index,follow"
        ogTitle="Bellhopt Locations"
        ogDescription={description}
        structuredData={structuredData}
      />

      <main className="w-[90%] max-w-[1100px] m-auto py-10 mobile:w-[95%]">
        <section className="rounded-3xl border border-[#E5E7EB] bg-white/95 backdrop-blur-2xl p-8 mobile:p-5 shadow-[0_24px_80px_rgba(15,23,42,0.12)]">
          <h1 className="font-segoe font-semibold text-[40px] mobile:text-[30px] text-[#111827]">
            Locations
          </h1>
          <p className="mt-3 text-[18px] mobile:text-[16px] text-[#6B7280] leading-8">
            Bellhopt Concierge supports pre-arrival groceries that are delivered, stocked, and
            organized. 24-hour lead time required.
          </p>
          <p className="mt-3 text-[#6B7280]">
            Indexable city pages start with a limited batch. Additional cities remain noindex until
            unique local content passes the quality gate.
          </p>
        </section>

        <section className="mt-6 rounded-3xl border border-[#E5E7EB] bg-white/92 backdrop-blur-2xl p-7 mobile:p-5 shadow-[0_18px_60px_rgba(15,23,42,0.10)]">
          <h2 className="font-segoe font-semibold text-[28px] mobile:text-[24px] text-[#111827]">
            City Pages
          </h2>
          <div className="grid grid-cols-2 mobile:grid-cols-1 gap-3 mt-5">
            {cityPages.map((cityItem) => (
              <Link
                key={cityItem.city}
                to={`/locations/${cityItem.city}/airbnb-grocery-delivery`}
                className="rounded-2xl border border-[#E5E7EB] p-4 bg-white/90 hover:bg-[#F9FAFB] transition-all"
              >
                <p className="font-segoe font-semibold text-[18px] text-[#111827]">
                  {cityItem.displayName}
                </p>
                <p className="text-[#6B7280] text-[14px] mt-1">
                  {cityItem.indexable ? "Indexable" : "Noindex placeholder"}
                </p>
              </Link>
            ))}
          </div>
        </section>
      </main>
    </div>
  );
}

export default LocationsHubPage;
